export class LoginVerificationContact {

  private internalId: string;
  private userInternalId: string;
  private type: string;
  private value: string;
  private maskedValue: string;

  constructor(internalId?: string,
              userInternalId?: string,
              type?: string,
              value?: string,
              maskedValue?: string) {
    this.internalId = internalId;
    this.userInternalId = userInternalId;
    this.type = type;
    this.value = value;
    this.maskedValue = maskedValue;
  }

  public get InternalId() {
    return this.internalId;
  }

  public get UserInternalId() {
    return this.userInternalId;
  }

  public get Type() {
    return this.type;
  }

  public get Value() {
    return this.value;
  }

  public get MaskedValue() {
    return this.maskedValue;
  }

  public set InternalId(internalId) {
    this.internalId = internalId;
  }

  public set UserInternalId(userInternalId) {
    this.userInternalId = userInternalId;
  }

  public set Type(type) {
    this.type = type;
  }

  public set Value(value) {
    this.value = value;
  }

  public set MaskedValue(maskedValue) {
    this.maskedValue = maskedValue;
  }
}
